/*
 * @Author: dongzhuo
 * @Date: 2020-07-15 09:55:34
 * @LastEditTime: 2021-04-22 11:47:20
 * @FilePath: \ncim_web\src\utils\http\http.js
 * @Description: 请求方法封装
 */
import request from "./request.js";
import { saveAs } from "file-saver";
/**
 * 请求地址必填
 */
function empty() {
  throw new Error("请求地址必填!");
}
export default {
  install(Vue) {
    Vue.prototype.$http = {
      /**
       *
       * @param {String} url 请求地址
       * @param {Object} params 请求参数
       * @description get请求
       */
      get: (url = empty(), params = {}) => {
        return request({
          url: url,
          method: "get",
          params: params
        });
      },
      /**
       *
       * @param {String} url 请求地址
       * @param {Object} params 请求参数
       * @param {Boolean} isBody 请求参数是否序列化，true 即请求头为application/json,false 则为www/urlencode...
       * @description post请求
       */
      post: (url = empty(), params = {}, isBody = false) => {
        const type = isBody ? "data" : "params";
        return request({
          url: url,
          method: "post",
          [type]: params
        });
      },
      /**
       *
       * @param {String} url 请求地址
       * @param {Object} params 请求参数
       * @description 上传附件等
       */
      upload: (url = empty(), params = {}) => {
        return request({
          url: url,
          headers: {
            "Content-Type": "multipart/form-data"
          },
          method: "post",
          data: params
        });
      },
      /**
       *
       * @param {String} url 请求地址
       * @param {Object} method 请求方式，默认是get
       * @param {Object} params 请求参数，默认为空{}
       * @param {Object} reType 响应方式，默认为blob
       * @param {Object} isPreView 是否预览，而不是下载，一般针对图片。默认为false
       * @param {Object} cb 预览下回调图片的base64值。
       * @description 文件下载请求
       */
      file: async (
        url = empty(),
        {
          method = "get",
          params = {},
          fileName = "",
          reType = "blob",
          isPreView = false,
          cb
        } = {
            method: "get",
            params: {},
            fileName: "",
            reType: "blob",
            isPreView: false
          }
      ) => {
        const res = await request({
          url: url,
          method: method,
          params: params,
          responseType: reType
        });
        const content = res;
        if (!isPreView) {
          saveAs(content, fileName);
        } else {
          // 图片直接转成base64显示
          const fileReader = new FileReader();
          fileReader.onload = function (e) {
            cb(e.target.result);
          };
          fileReader.readAsDataURL(content);
        }
        return res;
      }
    };
  }
};
